import { createSlice } from '@reduxjs/toolkit';

const Slicersreducerspayu = createSlice({
  name: 'pagopayu',
  initialState: {
    valorpago:0,
    checkboxPago: [true, true, true],
    opcionpago: "0",
    botonpagar: false
  },
  reducers: {
    cambiavalorpago: (state, action) => {
      state.valorpago = action.payload;
    },
    actualizarCheckboxs: (state, action) => {
      state.checkboxPago = action.payload;
    },
    actualizaropcionpago: (state, action) => {
      state.opcionpago = action.payload;
    },
    actualizarBotonPagar: (state, action) => {
      state.botonpagar = action.payload
    }
  }
});

export const {
    cambiavalorpago,
    actualizarCheckboxs,
    actualizaropcionpago,
    actualizarBotonPagar
  
} = Slicersreducerspayu.actions;

export default Slicersreducerspayu.reducer;